import React, { Fragment, FunctionComponent, useContext, useState } from 'react';
import { StepperContent, StepperHeader, StepperSubmit } from '../../../shared/Stepper';
import { FormContext } from '../../../../store/refinance/RefinanceContext';
import { formItems, getPostDataRemainingMortgage } from '../formItems';
import { useForm } from 'react-hook-form';
import { MortgagePart } from '../../MortgagePart';
import { API } from '../../../../services';
import { RemainingMortgageResponse } from '../../../../models/RemainingMortgageResponse';
import { numberToCurrency } from '../../../../utils/formatting';
import { scrollToTopCalculator } from '../../../../utils/general';

export const Step2: FunctionComponent<{ id: number }> = ({id}) => {
	const {
		register,
		handleSubmit,
		getValues,
		setError,
		clearErrors,
		formState: {errors, isValid},
	} = useForm({
		mode: 'onBlur',
		defaultValues: {
			//[formItems.salesCosts] : '',
		},
		shouldUnregister: true
	});

	const [completedText, setCompletedText] = useState('');
	const { updateForm, form, setRemainingMortgage, setIsLoading} = useContext(FormContext);

	const onSubmit = (data: any) => {

		const formData = {
			...form,
			...data,
		};

		setIsLoading(true)
		API.post<RemainingMortgageResponse>('calculator/calculateremainingmortgage', getPostDataRemainingMortgage(formData))
			.then((res) => {
				setRemainingMortgage(res);
				setCompletedText(numberToCurrency(res.totalResidualDebt, true));
				updateForm(data);
				setIsLoading(false);
				scrollToTopCalculator();
			})
			.catch((error) => {
				setIsLoading(false);
			});
	};

	const getValuesFormMortgagePart = (part: number) => {
		if (typeof form[formItems.step2.mortgageParts] !== 'undefined') {
			return form[formItems.step2.mortgageParts][part]
		}
	}

	return (
		<Fragment>
			<StepperHeader title="Huidige hypotheek" id={id} completedText={completedText}/>
			<StepperContent>
				<form onSubmit={handleSubmit(onSubmit)}>
					{[...Array(form[formItems.step1.countMortgageParts])].map((x, i) =>
						<MortgagePart
							register={register}
							errors={errors}
							part={i}
							setError={setError}
							clearErrors={clearErrors}
							getValues={getValues}
							values={getValuesFormMortgagePart(i)}
							key={i}></MortgagePart>
					)}
					<StepperSubmit id={id} isValidated={isValid}/>
				</form>
			</StepperContent>
		</Fragment>
	);
};
